import React, { useState } from 'react';
import { Book, Loader } from 'lucide-react';
import { aiAPI } from '../services/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import StatsAndTabs from './StatsAndTabs';

const Precedents = ({ onSuccess, stats, loading: statsLoading }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!query.trim()) {
      toast.error('Please enter a search query');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      const response = await aiAPI.findPrecedents({ query });

      setResult(response.result);
      toast.success('Precedent search completed!');
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Precedent search failed:', error);
      toast.error('Failed to search precedents');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setQuery('');
    setResult('');
  };

  return (
    <div>
      <div className="content-header">
        <div className="welcome-section">
          <h2>Legal Precedents</h2>
          <p>Find relevant legal precedents and case law</p>
        </div>
      </div>

      <StatsAndTabs stats={stats} loading={statsLoading} />

      <div className="tool-content">
        <div className="tool-header">
          <Book size={24} />
          <h3>Precedent Search</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Search Query</label>
            <textarea
              className="form-textarea"
              placeholder="Enter legal issue, case details, or keywords to find relevant precedents..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              disabled={loading}
              style={{ minHeight: '120px' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader size={16} className="animate-spin" />
                  Searching Precedents...
                </>
              ) : (
                <>
                  <Book size={16} />
                  Find Precedents
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {result && (
        <div className="tool-content">
          <div className="tool-header">
            <Book size={24} />
            <h3>Relevant Precedents</h3>
          </div>
          
          <MarkdownRenderer content={result} />

          <div style={{ marginTop: '16px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy Precedents
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Precedents;
